import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["innerClassName", "background", "color", "width", "maxWidth", "children", "shadow", "popperPlacement", "textLeft"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from "react";
import classNames from "classnames";
import O2TooltipPopoverWrapper, { propTypes } from "./o2-tooltip-popover-wrapper";
import PropTypes from "prop-types";

var O2Tooltip = function O2Tooltip(props) {
  var innerClassName = props.innerClassName,
      background = props.background,
      color = props.color,
      width = props.width,
      maxWidth = props.maxWidth,
      children = props.children,
      shadow = props.shadow,
      popperPlacement = props.popperPlacement,
      textLeft = props.textLeft,
      atributes = _objectWithoutPropertiesLoose(props, _excluded);

  var tooltipClasses = classNames("tipso_bubble", {
    "tipso--shadow": shadow
  });
  var classes = classNames("", innerClassName);
  return /*#__PURE__*/React.createElement(O2TooltipPopoverWrapper, _extends({
    popperClassName: "tipso_bubble",
    innerClassName: classes,
    tooltip: true,
    tooltipModifiers: {
      tooltipStyles: {
        position: "relative",
        background: background,
        color: color,
        maxWidth: maxWidth ? maxWidth + "px" : false,
        width: width ? width + "px" : false,
        textAlign: textLeft ? "start" : "center"
      },
      tooltipClassName: tooltipClasses,
      arrowClassName: "tipso_arrow",
      background: background
    }
  }, atributes), children);
};

O2Tooltip.propTypes = _objectSpread(_objectSpread({}, propTypes), {}, {
  shadow: PropTypes.bool,
  background: PropTypes.string,
  color: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  popperPlacement: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  textLeft: PropTypes.bool,
  autohide: PropTypes.bool
});
O2Tooltip.defaultProps = {
  placement: "top",
  autohide: true,
  trigger: "click hover focus",
  background: "#000",
  color: "#fff",
  maxWidth: 300,
  hideArrow: false,
  flip: false,
  width: false,
  textLeft: false,
  delay: 100
};
export default O2Tooltip;